import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { DeviceService } from '@helpers/device.service';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import * as models from '../models';
import { SettingsService } from '@app/settings.service';

@Injectable({
  providedIn: 'root',
})
export class FavouritesManagementService {
  private readonly url = `${environment.apiDataManagerUrl}/open-api/favorites`;

  constructor(
    private http: HttpClient,
    private deviceService: DeviceService,
    private _settingsService: SettingsService,
  ) {}

  public addRealPropertyObjectToFavourites(realPropertyId: number): Observable<number | string> {
    return this.addRealPropertyObjectToFavouritesOpen(realPropertyId);
  }

  public removeRealPropertyObjectFromFavouritesList(realPropertyId: number): Observable<number | string> {
    return this.removeRealPropertyObjectFromFavouritesListOpen(realPropertyId);
  }

  private addRealPropertyObjectToFavouritesOpen(realPropertyId: number) {
    const currentLanguageAsKey = this._settingsService.getCurrentShortLanguageAsKey();
    return this.deviceService
      .getDeviceUUID()
      .pipe(
        switchMap((uuid) =>
          this.http
            .post<models.AddRealPropertyToFavouritesOpenResp>(`${this.url}/${realPropertyId}/${uuid}`, null)
            .pipe(map((res) => (res.success === true ? res.data : res.messageText[currentLanguageAsKey]))),
        ),
      );
  }

  private removeRealPropertyObjectFromFavouritesListOpen(realPropertyId: number): Observable<number> {
    const currentLanguageAsKey = this._settingsService.getCurrentShortLanguageAsKey();
    return this.deviceService
      .getDeviceUUID()
      .pipe(
        switchMap((uuid) =>
          this.http
            .delete<models.RemoveRealPropertyObjectFromFavouritesOpenResp>(`${this.url}/${realPropertyId}/${uuid}`)
            .pipe(map((res) => (res.success === true ? res.data : res.messageText[currentLanguageAsKey]))),
        ),
      );
  }
}
